import React from "react";
import PropTypes from "prop-types";

import PrintDocumentInfoFabricator from "./printDocumentInfoFabricator";
import {IS_AS_WORK_ORDER, IS_DEALER_FLOW} from "../../../config";
import PrintDocumentInfoCustomer from "./printDocumentInfoCustomer";

export const getAddressFromObject = (userInfo) => {
  let displayAddress = "";
  [userInfo.city, userInfo.state, userInfo.postal].forEach(addressPart => { // 1) city 2) provence 3) postal
    if (addressPart) {
      if (displayAddress) {
        displayAddress += ", "
      }
      displayAddress += addressPart
    }
  });
  return displayAddress
}

const PrintDocumentInfo = (props) => {
  const {styles, userInfo, fabricatorData, assignQuotePopupCustomer, employeeSelected, messages, paymentState} = props;

  const {View, Text} = window.ReactPdfRenderer;

  const customerHasShippingAddress = userInfo.shipping && (["address1", "city", "postal"].some(key => {
    return userInfo.shipping[key] && (userInfo[key] !== userInfo.shipping[key])
  }));
  let shippingAddress = "";
  if (customerHasShippingAddress) {
    shippingAddress = getAddressFromObject(userInfo.shipping);
  }
  const threeColumns = (employeeSelected || (customerHasShippingAddress && !fabricatorData.isCaesarStone))
    && !fabricatorData.isAmericanStandard && !IS_DEALER_FLOW;

  return (
    <View style={styles.main}>
      <PrintDocumentInfoCustomer assignQuotePopupCustomer={assignQuotePopupCustomer}
                                 userInfo={userInfo}
                                 employeeSelected={employeeSelected}
                                 messages={messages}
                                 styles={styles}
                                 paymentState={paymentState}
                                 fabricatorData={fabricatorData}
                                 isDealerFlow={IS_DEALER_FLOW}/>
      {threeColumns ? (
        <View style={[styles.section, styles.sectionCenter]}>
          {!fabricatorData.isCaesarStone && (shippingAddress || userInfo.shipping.address1)
            ? <Text style={styles.mainTitle}>{messages["receipt.mainInfo.billingAddress"]}</Text>
            : null}
          {!fabricatorData.isCaesarStone && userInfo.shipping.address1
            ? <Text style={styles.mainText}>{userInfo.shipping.address1}</Text>
            : null}
          {!fabricatorData.isCaesarStone && shippingAddress
            ? <Text style={styles.mainText}>{shippingAddress}</Text>
            : null}
          {employeeSelected ? (
            <Text style={!fabricatorData.isCaesarStone && (shippingAddress || userInfo.shipping.address1)
              ? [styles.mainTitle, styles.mainTextEmail] : styles.mainTitle}>
              {messages["receipt.mainInfo.salesPerson"]}
            </Text>
          ) : null}
          {employeeSelected ? <Text style={styles.mainText}>{employeeSelected.fullName}</Text> : null}
        </View>
      ) : null}
      {IS_AS_WORK_ORDER || IS_DEALER_FLOW ? null : <PrintDocumentInfoFabricator fabricatorData={fabricatorData}
                                                              threeColumns={!!threeColumns}
                                                              styles={styles}
                                                              messages={messages}/>}
      {IS_DEALER_FLOW ? <PrintDocumentInfoCustomer assignQuotePopupCustomer={assignQuotePopupCustomer}
                                                   userInfo={userInfo}
                                                   employeeSelected={employeeSelected}
                                                   messages={messages}
                                                   styles={styles}
                                                   paymentState={paymentState}
                                                   fabricatorData={fabricatorData}
                                                   isStoreInformation={true}
                                                   isDealerFlow={false}/> : null}
    </View>
  )
};

PrintDocumentInfo.propTypes = {
  userInfo: PropTypes.object.isRequired,
  fabricatorData: PropTypes.object.isRequired,
  assignQuotePopupCustomer: PropTypes.object,
  styles: PropTypes.object.isRequired,
};

export default PrintDocumentInfo
